import React, { useState } from 'react'
import { makeStyles, Box, Button, MobileStepper, } from '@material-ui/core'
import { useTheme } from '@material-ui/core/styles'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@material-ui/icons'
import SwipeableViews from 'react-swipeable-views'
import { timingList } from '../data/timingList'
import BehaviorTrigger from '../elements/BehaviorCard'
/* Styles */
import { styles } from '../styles/SwipeScreenStyle'

// Style
const useStyles = makeStyles(styles)

export default function SwipeScreens({ checkedItems, setCheckedItems }) {
  const classes = useStyles()
  const theme = useTheme()
  const [activeStep, setActiveStep] = useState(0)
  const maxSteps = timingList.length

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const handleStepChange = (step) => {
    setActiveStep(step)
  }

  return (
    <Box className={classes.root}>
      <h4 className={classes.title}>行動リスト</h4>
      <p className={classes.subText}>
        ご自身の生活の中で「毎日している」行動を選びましょう！
      </p>
      <SwipeableViews
        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
        index={activeStep}
        onChangeIndex={handleStepChange}
        enableMouseEvents
      >
        {timingList.map((listItems, index) => (
          <div>
            {Math.abs(activeStep - index) <= 2 ? (
              <BehaviorTrigger
                listItems={listItems}
                checkedItems={checkedItems}
                setCheckedItems={setCheckedItems}
              />
            ) : null}
          </div>
        ))}
      </SwipeableViews>
      <MobileStepper
        steps={maxSteps}
        position="static"
        activeStep={activeStep}
        className={classes.stepper}
        nextButton={
          <Button
            size="small"
            onClick={handleNext}
            disabled={activeStep === maxSteps - 1}
          >
            Next
            {theme.direction === 'rtl' ? (
              <KeyboardArrowLeft />
            ) : (
              <KeyboardArrowRight />
            )}
          </Button>
        }
        backButton={
          <Button size="small" onClick={handleBack} disabled={activeStep === 0}>
            {theme.direction === 'rtl' ? (
              <KeyboardArrowRight />
            ) : (
              <KeyboardArrowLeft />
            )}
            Back
          </Button>
        }
      />
    </Box>
  )
}